import { EmployeeLiteModel, useGetEmployees } from 'api-hooks/employee';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import { useRouter } from 'next/router';
import * as React from 'react';

function transformer(item: EmployeeLiteModel): Option {
  return {
    id: item.id,
    label: item.name,
  };
}
export interface EmployeeSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
}

export default function EmployeeSelectInput(props: EmployeeSelectInputProps) {
  const { label, placeholder, value, onSelected } = props;

  const { pathname: key } = useRouter();

  const roles = React.useMemo(() => {
    switch (key) {
      case NavigationRoutes.PassportReport:
      case NavigationRoutes.VisaReport:
      case NavigationRoutes.ApecCardReport:
      case NavigationRoutes.InsuranceReport:
        return ['docs'].join('|');
      case NavigationRoutes.FlightReport:
        return ['flight'].join('|');
      case NavigationRoutes.HotelReport:
        return ['hotel'].join('|');
      default:
        return undefined;
    }
  }, [key]);

  const query = useGetEmployees({
    params: {
      limit: -1,
      filter: {
        roles,
      },
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  return (
    <CustomFormControl label={label} noMargin={props.noMargin}>
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
